import {useState} from 'react';

const useLocalStorage = (key, initialValue, type = null) => {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = localStorage.getItem(key);
            if (!item) return initialValue;

            const parsed = JSON.parse(item);

            // Если указан тип 'date', преобразуем в Date
            if (type === 'date') {
                return parsed ? new Date(parsed) : null;
            }

            return parsed;
        } catch (error) {
            console.error(`Error reading localStorage key "${key}":`, error);
            return initialValue;
        }
    });

    const setValue = (value) => {
        try {
            setStoredValue(value);
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(`Error setting localStorage key "${key}":`, error);
        }
    };

    const removeValue = () => {
        try {
            setStoredValue(null);
            localStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing localStorage key "${key}":`, error);
        }
    };

    return [storedValue, setValue, removeValue];
};

export default useLocalStorage;